import React from "react";
import "./mandatoryInputAsterisk.scss";

const MandatoryInputAsterisk = () => {
  return <span className="mandatory-input-asterisk">*</span>;
};

export default MandatoryInputAsterisk;
